export default __webpack_public_path__ + "static/media/2ad783ae6973961a6dc5eb3559ac2054.e59a5bba.png";